import { render } from "./ListItemLegalAlert.vue?vue&type=template&id=2513f915&scoped=true"
import script from "./ListItemLegalAlert.vue?vue&type=script&lang=js"
export * from "./ListItemLegalAlert.vue?vue&type=script&lang=js"

import "./ListItemLegalAlert.vue?vue&type=style&index=0&id=2513f915&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2513f915"]])

export default __exports__